export default __webpack_public_path__ + "static/media/Xarathrustra-minion-particle_0004_Niv-impact.b454d071.png";